 <template>
   <div>
      <Head :title="__('Dashboard')" />

          <div class="flex flex-col gap-3 mb-4 md:flex-row w-full items-center ticket-filters">
                <div class="mr-2 w-full">{{ __('Filtrar por') }}:</div>
                
                <text-input type="date" v-model="form.fini" :error="errors.fini" class="mr-2 w-full " :label="__('Date Start')" />
                <text-input type="date" v-model="form.fend" :error="errors.fend" class="mr-2 w-full" :label="__('Date End')" />
 
                <select-input v-if="!(hidden_fields && hidden_fields.includes('departments'))" v-model="form.category_id" class="mr-2 w-full mt-[23px]">
                    <option :value="null">{{ __('Department') }}</option>
                    <option v-for="s in departmentslist" :key="s.id" :value="s.id">{{ s.name }}</option>
                </select-input>
                
                <select-input v-model="form.priority_id" class=" mr-2 w-full mt-[23px]">
                    <option :value="null">{{ __('Priority') }}</option>
                    <option v-for="s in priorities" :key="s.id" :value="s.id">{{ s.name }}</option>
                </select-input>
                <select-input v-model="form.status_id" class="mr-2 w-full mt-[23px]">
                    <option :value="null">{{ __('Status') }}</option>
                    <option v-for="s in statuses" :key="s.id" :value="s.id">{{ s.name }}</option>
                </select-input>
              
            </div>

   

        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
              <tr class="text-left font-bold">
                <th class="px-6 pt-6 pb-4">{{ __('Department') }}</th>
                <th v-for="type in types" :key="type.id" class="px-6 pt-6 pb-4">{{ type.name }}</th>
              </tr>
              
              <tr v-for="department in categorieslist" :key="categorieslist.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                  <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('reports.details', [department.departamentid, department.id , department.link])">
                     {{ department.name }}
                  </Link>
                </td>
                <td v-for="type in types" class="border-t">
                  <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('reports.details', [department.departamentid,department.id , department.link])"> 
                    {{ department.totalbytype[type.id]}}
                  </Link>
                </td>

                <td class="border-t w-px">
                  <Link class="px-4 flex items-center" :href="this.route('reports.details', [department.departamentid, department.id , department.link])" tabindex="-1">
                    <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                  </Link>
                </td>
              </tr>
              <tr v-if="categorieslist.length === 0">
                <td class="border-t px-6 py-4" colspan="4">No found.</td>
              </tr>
            </table>
          </div>
          <pagination class="mt-6" :links="categorieslist.links" />   

        </div>
</template>
<script>
import Layout from '@/Shared/Layout'
import {Head, Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import TextInput from '@/Shared/TextInput'
import SearchInput from '@/Shared/SearchInput'
import SelectInput from '@/Shared/SelectInput'
import SelectInputFilter from '@/Shared/SelectInputFilter'
import Pagination from '@/Shared/Pagination'
import throttle from 'lodash/throttle'
  import pickBy from 'lodash/pickBy'
export default {
  metaInfo: { title: 'Reports' },
  components: {
        SearchInput,
        Icon,
        Head,
        Link,
        TextInput,
        SelectInputFilter,
        SelectInput,
    },
  layout: Layout,
  props: {
        fini: null,
        fend: null,
        auth: Object,
        priorities: Array,
        statuses: Array,
        types: Array,
        categories: Array,
        departments: Array,
        departmentslist : Array,
        categorieslist : Array,
        filters: Object,
        
    },
    created() {
        console.log(this.departments)
    },
    data() {
        return {
            user_access: this.$page.props.auth.user.access,
            form: {
                fini: this.filters.fini,
                fend: this.filters.fend, 
                search: this.filters.search,
                customer_id: this.filters.customer_id,
                field: this.filters.field,
                direction: this.filters.direction,
                priority_id: this.filters.priority_id ?? null,
                status_id: this.filters.status_id ?? null,
                type_id: this.filters.type_id ?? null,
                category_id: this.filters.category_id ?? null,
                department_id: this.filters.department_id ?? null,
            },
        
            errors: [],
            loading: false,
        }
    },
      watch: {
          form: {
              deep: true,
              handler: throttle(function() {
                  this.$inertia.get(this.route('reports'), pickBy(this.form), { replace: true, preserveState: true })
              }, 150),
          },
      },
}
</script>
